module.exports = __webpack_public_path__ + "img/mizuni.259413ed.svg";